<template>
  <a-drawer
    :open="open"
    :width="480"
    class="custom-class"
    root-class-name="root-class-name"
    placement="right"
    @close="close"
  >
    <section>
      <div>
        <Text :type="'subHeader'" :text="'Map product to Depot'" />
        <Text :type="'textFadedMedium'" :text="'Set product price quantity '" />
      </div>

      <div v-if="activeProducts.length" class="mt-2">
        <div v-bind:key="index" v-for="(product, index) in activeProducts">
          <div
            class="flex items-center justify-between px-3 py-2 mb-3 border rounded-lg border-grey300"
          >
            <div>
              <div class="flex items-center">
                <span>
                  <img src="@/assets/svg/productPms.svg" />
                </span>
                <span class="text-sm text-grey500">
                  {{ product.productName }}
                </span>
              </div>
              <div>
                <p class="mt-2 text-base text-grey500">
                  Product Price: {{ product.productPrice }}
                </p>
              </div>
            </div>

            <a-dropdown placement="bottomRight" :trigger="['click']">
              <a class="ant-dropdown-link" @click.prevent>
                <img src="@/assets/svg/ThreeDOT.svg" />
              </a>
              <template #overlay>
                <a-menu>
                  <a-menu-item
                    class="flex items-center px-2 py-1"
                    key="0"
                    @click="editProduct(product)"
                  >
                    <img class="inline h-5 mr-2" src="@/assets/svg/edit.svg" />
                    Edit
                  </a-menu-item>
                  <a-menu-divider />
                  <a-menu-item
                    class="flex items-center px-2 py-1"
                    key="1"
                    @click="deleteProduct(product)"
                  >
                    <img class="inline h-5 mr-2" src="@/assets/svg/Bin.svg" />
                    Delete
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
            <!-- <div class="relative cursor-pointer">
              <img src="@/assets/svg/elipsis-horizontal.svg" />
              <div class="absolute right-0 px-3 bg-white top-6">
                <div class="">
                  <p @click="editProduct(product)">Edit</p>
                  <p>Delete</p>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="mt-4">
        <!-- <Text type="form-label" :text="'Select product and limit'" /> -->
        <form @submit.prevent="mapProductDepot">
          <div class="mt-3">
            <LabelText
              :forVal="'productSelect'"
              :labelText="'Select product'"
            />
            <select
              class="w-full px-4 py-2 border-[1px] text-base bg-transparent rounded-lg border-grey300 font-quietSans placeholder-grey500 outline-foundationGrey500 focus:border-foundationGrey500"
              name="name"
              v-model="productName"
              :value="productName"
            >
              <option value="" selected disabled>Select a product</option>
              <option
                :value="product.name"
                v-bind:key="product.id"
                v-for="product in depotProducts"
              >
                {{ product.name }}
              </option>
            </select>
          </div>

          <div class="mt-3">
            <LabelText
              :forVal="'product_volume'"
              :labelText="'Maximum Volume'"
            />

            <input
              class="w-full px-4 py-2 text-sm border rounded-md border-foundationGrey500 font-quietSans placeholder-foundationGrey500 outline-foundationGrey500 focus:border-foundationGrey500"
              v-model="productVolume"
              :placeholder="'50,000l'"
              :name="'productVolume'"
              :type="'text'"
              :value="productVolume"
            />
          </div>

          <div class="mt-3">
            <LabelText
              :forVal="'current_volume'"
              :labelText="'Current Volume'"
            />

            <input
              class="w-full px-4 py-2 text-sm border rounded-md border-foundationGrey500 font-quietSans placeholder-foundationGrey500 outline-foundationGrey500 focus:border-foundationGrey500"
              v-model="newVolume"
              :placeholder="'Enter new volume'"
              :name="'newPrice'"
              :type="'text'"
              :value="newVolume"
            />
          </div>

          <div class="mt-3">
            <LabelText
              :forVal="'product_volume'"
              :labelText="'Product Price'"
            />

            <input
              class="w-full px-4 py-2 text-sm rounded-md border-[1px] border-foundationGrey500 font-quietSans placeholder-foundationGrey500 outline-foundationGrey500 focus:border-foundationGrey500"
              v-model="productPrice"
              :placeholder="'Set product price'"
              :name="'productPrice'"
              :type="'text'"
              :value="productPrice"
            />
          </div>

          <div class="mt-3">
            <LabelText :forVal="'startDate'" :labelText="'Price Start Date'" />
            <VueDatePicker
              color="#00903a"
              input-size="sm"
              v-model="startDate"
              :min-date="todayDate"
              no-label
              format="YYYY-MM-DDTHH:mm:ss"
            />
          </div>

          <div class="mt-3">
            <LabelText :forVal="'date'" :labelText="'Price End Date'" />
            <VueDatePicker
              color="#00903a"
              input-size="sm"
              v-model="endDate"
              :min-date="todayDate"
              no-label
              format="YYYY-MM-DDTHH:mm:ss"
            />
          </div>

          <div
            v-if="depotProducts.length > 1"
            class="flex items-center my-2 cursor-pointer"
            @click="addProduct"
          >
            <span><img src="@/assets/svg/addGreen.svg" /></span>
            <p class="ml-2 text-sm text-primaryGreen">Add more product</p>
          </div>

          <div class="mt-4">
            <FormSubmitInput
              :loading="secondFormLoading"
              :val="'Map Product'"
            />
          </div>
        </form>
      </div>
      <CreateDepotGroupModalVue
        :getDepotGroups="getDepotGroups"
        :handleOk="handleOk"
        :isOpen="isOpen"
        :close="close"
      />
    </section>
  </a-drawer>
</template>

<script>
//libraries
import moment from "moment";

import Text from "@/components/UI/Text/Text.vue";
import DrawerInput from "@/components/UI/Inputs/DrawerInput.vue";
import LabelText from "@/components/UI/Text/LabelText.vue";
import SelectWrapper from "@/components/UI/Selects/DrawerSelect.vue";
import FadedBorderWrapper from "@/components/UI/Wrappers/FadedBorderWrapper.vue";
import CheckInput from "@/components/UI/Inputs/CheckInput.vue";
import SubmitButton from "@/components/UI/Inputs/FormSubmitInput.vue";
import depotService from "@/services/depot-service";
import { useToast } from "vue-toastification";
import AddProductDepot from "@/components/pages/Depot/AddProductDepot.vue";
import FlexWrapper from "@/components/UI/Wrappers/FlexWrapper.vue";
import FormSubmitInput from "@/components/UI/Inputs/FormSubmitInput.vue";
import CreateDepotGroupModalVue from "@/components/pages/Depot/Modal/DepotGroupModal.vue";
import stripNonNumber from "@/utils/stripNonNumber.js";

export default {
  props: ["open", "close", "getDepot", "products", "getDepotDetails"],
  components: {
    CreateDepotGroupModalVue,
    Text,
    DrawerInput,
    AddProductDepot,
    LabelText,
    SelectWrapper,
    FadedBorderWrapper,
    FlexWrapper,
    CheckInput,
    SubmitButton,
    FormSubmitInput,
  },
  data() {
    return {
      todayDate: moment().format("YYYY-MM-DD"),
      isOpen: false,
      toast: useToast(),
      depotName: "",
      number: "",
      loading: false,
      depotProducts: null,
      checked: false,
      selectedProducts: [],
      secondFormLoading: false,
      newSelectedProducts: [],
      activeProducts: [],
      productVolume: "",
      productName: "",
      newPrice: "",
      startDate: "",
      endDate: "",
      productPrice: "",
      newVolume: "",
      openEdit: false,
    };
  },

  mounted() {
    this.handleGetProduct();
  },

  methods: {
    //utilities
    handleDropdownChange() {
      // Handle the selected option change here
    },

    deleteProduct(product) {
      const selectedIndex = this.activeProducts.findIndex(
        (item) => item.id == product.id
      );
      this.activeProducts.splice(selectedIndex, 1);
    },
    
    editProduct(product) {
      this.productName = product.productName;
      this.newPrice = product.newPrice;
      this.productVolume = product.productVolume;
      this.startDate = product.startDate;
      this.endDate = product.endDate;
      this.productPrice = product.productPrice;
      this.newVolume = product.newVolume;
    },
    showModal() {
      this.isOpen = true;
    },
    handleOk() {
      this.isOpen = false;
    },
    validateData(submitType) {
      if (submitType) {
        if (
          (!this.productName ||
            !this.startDate ||
            !this.endDate ||
            !this.productVolume ||
            !this.productPrice ||
            !this.newVolume) &&
          this.activeProducts.length
        ) {
          return { value: true, submitValidate: true };
        } else {
          if (
            !this.productName ||
            !this.startDate ||
            !this.endDate ||
            !this.productVolume ||
            !this.productPrice ||
            !this.newVolume
          ) {
            return { submitValidate: false, value: false };
          }
          return { submitValidate: true, value: false };
        }
      } else {
        if (
          !this.productName ||
          !this.startDate ||
          !this.endDate ||
          !this.productVolume ||
          !this.productPrice ||
          !this.newVolume
        ) {
          return false;
        }
        return true;
      }
    },

    resetFields() {
      (this.productName = ""),
        (this.newPrice = ""),
        (this.startDate = ""),
        (this.endDate = ""),
        (this.productVolume = "");
      this.productPrice = "";
      this.newVolume = "";
    },
    resolveId(productName) {
      return this.depotProducts.find((item) => item.name == productName).id;
    },
    addProduct(shouldValidate) {
      // Validate before pushing
      if (!shouldValidate) {
        if (!this.validateData()) {
          this.toast.error(
            "All fields for the current product should be filled",
            { timeout: 5000 }
          );
          this.loading = false;

          return;
        }
      }

      const findVal = this.activeProducts.findIndex(
        (item) => item.productName == this.productName
      );

      // Update if you find a new one
      if (findVal !== -1) {
        this.activeProducts[findVal] = {
          productName: this.productName,
          newPrice: this.newPrice,
          productVolume: this.productVolume,
          startDate: this.startDate,
          endDate: this.endDate,
          productPrice: this.productPrice,
          productId: this.resolveId(this.productName),
          newVolume: this.newVolume,
        };
      } else {
        // create a new one
        this.activeProducts.push({
          productName: this.productName,
          newPrice: this.newPrice,
          productVolume: this.productVolume,
          startDate: this.startDate,
          endDate: this.endDate,
          productId: this.resolveId(this.productName),
          productPrice: this.productPrice,
          newVolume: this.newVolume,
        });
      }

      this.resetFields();
    },

    //Requests

    selectChanged(id) {
      if (this.newSelectedProducts.includes(id)) {
        const indExisting = this.newSelectedProducts.indexOf(id);
        this.newSelectedProducts.splice(indExisting, 1);
        return;
      }
      this.newSelectedProducts = [...this.newSelectedProducts, id];
      if (this.selectedProducts[index].selected) {
        const { minCapacity, maxCapacity, ...rest } =
          this.selectedProducts[index];
        this.selectedProducts[index] = {
          ...rest,
          selected: false,
        };
      } else {
        this.selectedProducts[index].selected = true;
      }
    },
    async mapProductDepot(e) {
      this.secondFormLoading = true;
      const validateVal = this.validateData(true);

      if (!validateVal?.submitValidate) {
        this.toast.error(
          "All fields for the current product should be filled",
          { timeout: 5000 }
        );
        this.secondFormLoading = false;
        return;
      }

      !validateVal?.value && this.addProduct(true);
      // convert the data gotten to the correct form
      const payload = this.activeProducts.map((item) => {
        return {
          productId: item.productId,
          price: +stripNonNumber(item.productPrice),
          maxCapacity: +stripNonNumber(item.productVolume),
          currentQuantity: +stripNonNumber(item.newVolume),
          startDate: item.startDate,
          endDate: item.endDate,
        };
      });
      try {
        const tDepotId = new URLSearchParams(window.location.search);
        const mapSales = await depotService.changeDepotPrice(
          `Depot/AddProductSale?depotId=${tDepotId.get("id")}`,
          payload
        );

        this.toast.success("Depot Product Price mapped successfully", {
          timeout: 5000,
        });
        this.close();
        this.getDepotDetails();
      } catch (e) {
      } finally {
        this.secondFormLoading = false;
      }
    },

    computeIndex(id, array_) {
      return array_.findIndex((item) => item.id === id);
    },
    async handleGetProduct() {
      try {
        let depotProducts_ = await depotService.getProducts();

        this.products.forEach((item) => {
          depotProducts_.data.splice(
            this.computeIndex(item.depotProductId, depotProducts_.data),
            1
          );
        });
        this.depotProducts = depotProducts_.data;

        const nSelectedProduct = depotProducts_.data.map((item) => {
          return { selected: false, productId: item.id };
        });

        this.selectedProducts = nSelectedProduct;
      } catch (e) {
        this.toast.error("Couldn't fetch depot product", { timeout: 5000 });
      }
    },
    collectProductData(e, currIndex, left, right) {
      if (right) {
        this.selectedProducts[currIndex].maxCapacity = e.target.value;
      }
      if (left) {
        this.selectedProducts[currIndex].minCapacity = e.target.value;
      }
    },
  },
};
</script>

<style></style>
